import React from 'react'
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import FigmaPluginModal from '../../Display/Html/Modals/FigmaPluginModal';
import EmptyPage from './EmptyPage';
import VersionPage from './VersionPage';
import Preloader from '../../../../../Components/Common/Preloader';

function Facebook() {
  const selectVersions = createSelector(state => state.Campaign, state => ({
    versions: state.versions,
    campaignLoader: state.campaignLoader
  }));
  const {versions, campaignLoader} = useSelector(selectVersions); 
  
  return (
    <React.Fragment>
      {campaignLoader ? <Preloader /> : null}
      {versions && versions.length > 0 ?
        <VersionPage />
        :
        <EmptyPage />
      }
      <FigmaPluginModal />
    </React.Fragment>
  )
}

export default Facebook
